document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.getElementById('mobile-search-toggle');
  const searchWrapper = document.getElementById('mobile-search-wrapper');
  const input = document.querySelector('.searchform--form input[name="q"]');

  // Mobile Search Toggle
  if (toggle && searchWrapper) {
    const openSearch = () => {
      searchWrapper.classList.toggle('active');
      const focusInput = searchWrapper.querySelector('input[name="q"]');
      if (focusInput) focusInput.focus();
    };

    toggle.addEventListener('click', e => {
      e.stopPropagation();
      openSearch();
    });

    document.addEventListener('click', e => {
      if (!searchWrapper.contains(e.target) && !toggle.contains(e.target)) {
        searchWrapper.classList.remove('active');
      }
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        searchWrapper.classList.remove('active');
      }
    });
  }

  // Placeholder Typing Animation
  if (input) {
    const baseText = "Search for ";
    const phrases = [
      "Lithium Batteries",
      "Camping Fans",
      "Inverters",
      "Solar Panels",
      "DCDC Chargers"
    ];

    let phraseIndex = 0;
    let charIndex = 0;
    let isDeleting = false;
    const typingSpeed = 50;
    const deletingSpeed = 25;
    const pauseAfterWord = 1000;
    const pauseAfterDelete = 300;

    const type = () => {
      const fullText = baseText + phrases[phraseIndex];
      const currentText = isDeleting
        ? fullText.slice(0, charIndex--)
        : fullText.slice(0, charIndex++);

      input.setAttribute('placeholder', currentText);

      if (!isDeleting && charIndex > fullText.length) {
        isDeleting = true;
        return setTimeout(type, pauseAfterWord);
      }

      if (isDeleting && charIndex === baseText.length) {
        isDeleting = false;
        phraseIndex = (phraseIndex + 1) % phrases.length;
        return setTimeout(type, pauseAfterDelete);
      }

      setTimeout(type, isDeleting ? deletingSpeed : typingSpeed);
    };

    type();
  }
});
